import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Language } from "../i18n/strings";

interface LangState {
  lang: Language;
  setLang: (lang: Language) => void;
}

export const useLangStore = create<LangState>()(
  persist(
    (set) => ({
      lang: "en",
      setLang: (lang) => set({ lang }),
    }),
    { name: "clearbooks.lang" }
  )
);
